export const spacing = {
  // Pixel values (for use with px units)
  xs: 4,     // 4px
  sm: 8,     // 8px  
  md: 12,    // 12px
  lg: 16,    // 16px
  xl: 20,    // 20px
  xxl: 24,   // 24px
  xxxl: 32,  // 32px 
  xxxxl: 48, // 48px

  // MUI-compatible values (use directly in sx prop)
  mui: {
    xs: 0.5,   // 4px (0.5 * 8)
    sm: 1,     // 8px (1 * 8)
    md: 1.5,   // 12px (1.5 * 8)
    lg: 2,     // 16px (2 * 8)
    xl: 2.5,   // 20px (2.5 * 8)
    xxl: 3,    // 24px (3 * 8)
    xxxl: 4,   // 32px (4 * 8)
    xxxxl: 6,  // 48px (6 * 8)
  },
} as const;